import { useCallback, useEffect, useRef, useState } from 'react';
import { getDeviceUuid } from '../api';

const PENDING = 'pill_reminder_pending_native_alarm_success';
const SHOWN = 'pill_reminder_shown_native_alarm_success';
const read = key => JSON.parse(localStorage.getItem(key) || '{}') || {};
const trace = (stage, requestId) => {
    try { window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'ALARM_CONFIRM_TRACE', stage, requestId })); } catch {}
};

// Presentation has its own queue. Saving and FINISHED ACK never wait for the UI.
export default function useNativeAlarmSuccess(show, ready) {
    const callback = useRef(show);
    callback.current = show;
    const [revision, setRevision] = useState(0);
    const enqueue = useCallback(request => {
        try {
            if (read(SHOWN)[request.requestId]) return;
            localStorage.setItem(PENDING, JSON.stringify({ ...read(PENDING), [request.requestId]: request }));
            trace('web_notice_queued', request.requestId);
            setRevision(value => value + 1);
        } catch {} // A presentation/storage error must never retry a saved dose.
    }, []);

    useEffect(() => {
        const present = () => {
            if (!ready || document.visibilityState === 'hidden') return;
            try {
                const pending = read(PENDING);
                const shown = read(SHOWN);
                const uuid = getDeviceUuid();
                const requests = Object.values(pending).filter(request => request.deviceUuid === uuid && !shown[request.requestId]);
                if (!requests.length) return;
                // Report all results waiting behind a hidden/loading home in one notice.
                callback.current({ ...requests[0], logIds: [...new Set(requests.flatMap(request => request.logIds))] });
                for (const { requestId } of requests) {
                    shown[requestId] = true;
                    localStorage.setItem(SHOWN, JSON.stringify(shown));
                    trace('web_notice_shown', requestId);
                    delete pending[requestId];
                }
                localStorage.setItem(PENDING, JSON.stringify(pending));
            } catch {}
        };
        present();
        document.addEventListener('visibilitychange', present);
        return () => document.removeEventListener('visibilitychange', present);
    }, [ready, revision]);
    return enqueue;
}
